module.exports = __webpack_public_path__ + "static/media/Bokyung Lee.1734ae33.png";